import { Chip } from '@mui/material';
import { PaymentStatus } from 'src/utils/constants/enum';
import { convertToStartCase } from 'src/utils/helpers/stringHelpers';

export const getInvoiceStatus = (status?: PaymentStatus) => {
  switch (status) {
    case PaymentStatus.success:
      return <Chip size="small" color="success" label="Success" />;
    case PaymentStatus.refunded:
      return <Chip size="small" color="warning" label={convertToStartCase(status)} />;
    default:
      return <Chip size="small" color="error" label="Failed" />;
  }
};
